import { toast } from 'sonner';

type ToastType = 'success' | 'error' | 'warning' | 'info';

export function useToast() {
  const showToast = (message: string, type: ToastType = 'success') => {
    switch (type) {
      case 'success':
        toast.success(message);
        break;
      case 'error':
        toast.error(message);
        break;
      case 'warning':
        toast.warning(message);
        break;
      case 'info':
        toast.info(message);
        break;
    }
  };

  return { showToast };
}
